import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from 'src/app/core/services/utility.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-update-benefits-modal',
  templateUrl: './update-benefits-modal.component.html',
  styleUrls: ['./update-benefits-modal.component.css'],
})
export class UpdateBenefitsModalComponent implements OnInit {
  @ViewChild('declineForm', { static: false }) declineForm: NgForm;
  @Input() category: string;
  @Input() mode: string;
  @Input() data: any[];
  @Input() selected: { [key: string]: any };
  @Input() proxyID: number;
  portalSettings: any;
  formData: { [key: string]: any } = {};
  dependents: any[] = [];
  filteredDependents: any[] = [];
  rejectionText: string;
  showDeclineType: boolean;
  notReachMinCount = false;
  MaxDependentCount: number;
  MinDependentCount: number;
  declineList: any[];
  alert: { type: string; msg: string };
  showPrimaryInput: boolean;
  showSecondaryInput: boolean;
  fileData: any[];

  constructor(
    private portalSettingsService: PortalSettingsService,
    private employeeService: EmployeeService,
    private ngbActiveModal: NgbActiveModal,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.formData.newFiles = [];
    this.formData.Primary = null;
    this.formData.Secondary = null;
    this.formData.Notes = null;
    this.formData.primaryInput = null;
    this.formData.secondaryInput = null;
    this.formData.primaryRelationship = null;
    this.formData.secondaryRelationship = null;
    this.rejectionText =
      this.portalSettings.Step3RejectionText.ConfigValue != null
        ? this.portalSettings.Step3RejectionText.ConfigValue.replace('target=""', 'target="_blank"')
        : '';
    this.formData.selectedDecline = null;
    this.showDeclineType =
      this.portalSettings.BNDeclineComboBoxName.ConfigValue != null && this.portalSettings.BNDeclineComboBoxName.ConfigValue != ''
        ? true
        : false;
    this.formData.totalCount = 0;

    if (this.data != null && this.selected != null) {
      var selectedItem = null;
      for (const key in this.selected.SelectedValue) {
        const val = this.selected.SelectedValue[key];
        if (val) selectedItem = key;
      }
      if (selectedItem != null) {
        this.formData.showAtt = this.selected.SelectedOption[selectedItem].CodeSettingIsAttachmentsAllowed;
        this.formData.showBen = this.selected.SelectedOption[selectedItem].CodeSettingIsBeneficiaryShown;
        this.formData.showBenFree = this.selected.SelectedOption[selectedItem].CodeSettingIsBenficiaryFreeText;
        this.formData.showDep = this.selected.SelectedOption[selectedItem].CodeSettingIsDependentsShown; //how portal setting benefit code works for 3? using this parameter?
        this.formData.showNote = this.selected.SelectedOption[selectedItem].CodeSettingIsDeclineNotesRequired;
        this.MaxDependentCount = this.selected.SelectedOption[selectedItem].MaxDependentCount;
        this.MinDependentCount = this.selected.SelectedOption[selectedItem].MinDependentCount;
      } else {
        this.data.forEach(val => {
          this.formData.showAtt = val.CodeSettingIsAttachmentsAllowed;
          this.formData.showBen = val.CodeSettingIsBeneficiaryShown;
          this.formData.showBenFree = val.CodeSettingIsBenficiaryFreeText;
          this.formData.showDep = val.CodeSettingIsDependentsShown; //how portal setting benefit code works for 3? using this parameter?
          this.formData.showNote = val.CodeSettingIsDeclineNotesRequired;
          this.MaxDependentCount = val.MaxDependentCount;
          this.MinDependentCount = val.MinDependentCount;
          return true;
        });
      }
    }
    if (this.mode != 'decline') {
      this.getDependents();
    }

    if (this.mode == 'decline') {
      this.employeeService.getVistaOptions('benefitdeclinereason').then((response: any) => {
        this.declineList = response;
      });
    }
  }
  getDependents() {
    this.employeeService.getDependents(this.proxyID).then((response: any) => {
      this.dependents = response;
      if (this.formData.showBenFree)
        this.dependents = this.dependents.concat({
          Name: 'Type in a name & relationship...',
          KeyID: -1,
          DependentRequestID: null,
          Disabled: false,
        });
      if (this.MaxDependentCount == 0 && this.formData.showDep) {
        this.alert = { type: 'warning', msg: "You've reached the maximum number of dependents for this option." };
        this.dependents.forEach(val => {
          val.Disabled = true;
        });
      }
      if (this.formData.totalCount < this.MinDependentCount && this.formData.showDep) {
        this.notReachMinCount = true;
        this.alert = { type: 'warning', msg: "You've not reached the minimum number of dependents for this option." };
      }
    });
  }

  updateCount() {
    this.formData.totalCount = 0;
    this.notReachMinCount = false;
    this.dependents.forEach(val => {
      if (val.IsSelected) this.formData.totalCount++;
    });
    if (this.formData.totalCount == this.MaxDependentCount) {
      this.dependents.forEach(val => {
        if (!val.IsSelected) val.Disabled = true;
      });
    } else {
      this.dependents.forEach(val => {
        val.Disabled = false;
      });
    }
    if (this.formData.totalCount == this.MaxDependentCount && this.formData.showDep)
      this.alert = { type: 'warning', msg: "You've reached the maximum number of dependents for this option." };
    else if (this.formData.totalCount < this.MinDependentCount && this.formData.showDep) {
      this.alert = { type: 'warning', msg: "You've not reached the minimum number of dependents for this option." };
      this.notReachMinCount = true;
    } else this.alert = null;
  }

  primaryChanged() {
    if (this.formData.Primary == null) {
      this.formData.Secondary = null;
      this.filteredDependents = [];
      this.showPrimaryInput = false;
      this.showSecondaryInput = false;
    } else {
      if (this.formData.Primary.KeyID == -1 && !this.formData.Primary.hasOwnProperty('SSN')) this.showPrimaryInput = true;
      else this.showPrimaryInput = false;
      var filteredDependents = [];

      this.dependents.forEach(val => {
        if (
          this.formData.Primary.KeyID != val.KeyID ||
          (this.formData.Primary.KeyID == -1 && val.Name == 'Type in a name & relationship...') ||
          (this.formData.Primary.KeyID == -1 && this.formData.Primary.Name != val.Name)
        ) {
          filteredDependents.push(val);
        }
      });
      this.filteredDependents = filteredDependents;
    }
  }

  secondaryChanged() {
    if (this.formData.Secondary == null) {
      this.showSecondaryInput = false;
    } else {
      if (this.formData.Secondary.KeyID == -1 && !this.formData.Secondary.hasOwnProperty('SSN')) this.showSecondaryInput = true;
      else this.showSecondaryInput = false;
    }
  }

  proceedClicked() {
    if (this.formData.Primary != null) {
      if (this.formData.Primary.KeyID == -1) {
        this.formData.Primary.NameP = this.formData.primaryInput;
        this.formData.Primary.RelationshipP = this.formData.primaryRelationship;
      }
    }
    if (this.formData.Secondary != null) {
      if (this.formData.Secondary.KeyID == -1) {
        this.formData.Secondary.NameS = this.formData.secondaryInput;
        this.formData.Secondary.RelationshipS = this.formData.secondaryRelationship;
      }
    }
    this.formData.type = 'proceed';
    var dependents = [];
    this.dependents.forEach(val => {
      if (val.IsSelected) {
        dependents.push(val);
      }
    });
    this.formData.Dependents = dependents;
    this.ngbActiveModal.close(this.formData);
  }

  closeClicked() {
    this.formData.type = 'close';
    this.ngbActiveModal.close(this.formData);
  }

  readFile(file, call) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  upload() {
    this.fileData = [];
    var draggedFile = this.formData.fileDrop;
    this.formData.fileDrop = [];
    if (draggedFile != null) {
      for (var i = 0; i < draggedFile.length; i++) {
        var n = 0;
        this.readFile(draggedFile[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
            if (n == draggedFile.length - 1) {
              this.fileData.forEach(val => {
                draggedFile.forEach(val2 => {
                  if (val2.size == val.size && val.name == val2.name) {
                    this.formData.newFiles.push({ File: val.data[1], Filename: this.utilityService.formatAttachmentName(val2.name) });
                  }
                });
              });
            }
            n++;
          });
        });
      }
    }
  }

  deleteUnsavedAttachment(file) {
    var index = this.formData.newFiles.indexOf(file);
    this.formData.newFiles.splice(index, 1);
  }
}
